const headerTabs = [
  {
    title: 'درباره ما',
    link: 'https://tapsi.ir/about',
  },
  {
    title: 'تماس با ما',
    link: 'https://tapsi.ir/contact',
  },
  {
    title: 'خدمات سازمانی',
    link: 'https://tapsi.ir/corporate',
  },
  {
    title: 'فرصت‌های شغلی',
    link: '/',
    active: true,
  },
  {
    title: 'وبلاگ',
    link: 'https://blog.tapsi.ir/',
  },
];

export default headerTabs;

export const getActiveTab = path =>
  headerTabs
    .filter(tab => path.startsWith(tab.link))
    .reduce((activeTab, tab) => (path.match(activeTab.link)[0].length >= path.match(tab.link)[0].length ? activeTab : tab), {
      title: '',
      link: '',
    });
